import { render, staticRenderFns } from "./deviceSignTable.vue?vue&type=template&id=4e87e29f&scoped=true&"
import script from "./deviceSignTable.vue?vue&type=script&lang=js&"
export * from "./deviceSignTable.vue?vue&type=script&lang=js&"
import style0 from "./deviceSignTable.vue?vue&type=style&index=0&id=4e87e29f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e87e29f",
  null
  
)

export default component.exports